<template>
  <div>
    <p>
      <strong>Fecha de Accidente: </strong>
      {{ dateOccurred | shortDate }}
    </p>
    <p>
      <strong>Fecha de Asignación: </strong>
      {{ dateAssignment | shortDate }}
    </p>
  </div>
</template>

<script>
export default {

  name: 'sinisterDates',

  props: {
    dateOccurred: [String, Date],
    dateAssignment: [String, Date],
  },

  data() {
    return {

    };
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/RoadSinisters/SinisterDates.vue